var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manage-position-title title-notab"},[_vm._v(" จัดการอนุมัติโครงสร้างบริษัท ")])
}
var staticRenderFns = []

export { render, staticRenderFns }